export default __webpack_public_path__ + "static/media/screw2.9e4a4c4f.png";